// Load templates from the templates directory structure
// This mimics the backend's load_templates() function but for frontend

import femaBugOutBag from './templates/fema/bug_out_bag.json';
import femaHomeEmergency from './templates/fema/home_emergency.json';
import femaFirstAid from './templates/fema/first_aid.json';
import femaVehicleEmergency from './templates/fema/vehicle_emergency.json';
import femaGetHomeBag from './templates/fema/get_home_bag.json';
import femaMetadata from './templates/fema/metadata.json';

import redCrossBasic3Day from './templates/red_cross/basic_3day.json';
import redCrossHurricaneKit from './templates/red_cross/hurricane_kit.json';
import redCrossWildfireKit from './templates/red_cross/wildfire_kit.json';
import redCrossMetadata from './templates/red_cross/metadata.json';

import cdcPandemicKit from './templates/cdc/pandemic_kit.json';
import cdcMedicationKit from './templates/cdc/medication_kit.json';
import cdcMetadata from './templates/cdc/metadata.json';

import wahleTecIfak from './templates/wahle_tec/ifak.json';
import wahleTecMetadata from './templates/wahle_tec/metadata.json';

export function loadTemplates() {
  // Return templates organized by source (same structure as backend API)
  return {
    fema: {
      name: femaMetadata.name,
      description: femaMetadata.description,
      website: femaMetadata.website,
      logo: femaMetadata.logo,
      templates: {
        bug_out_bag: femaBugOutBag,
        home_emergency: femaHomeEmergency,
        first_aid: femaFirstAid,
        vehicle_emergency: femaVehicleEmergency,
        get_home_bag: femaGetHomeBag,
      },
    },
    red_cross: {
      name: redCrossMetadata.name,
      description: redCrossMetadata.description,
      website: redCrossMetadata.website,
      logo: redCrossMetadata.logo,
      templates: {
        basic_3day: redCrossBasic3Day,
        hurricane_kit: redCrossHurricaneKit,
        wildfire_kit: redCrossWildfireKit,
      },
    },
    cdc: {
      name: cdcMetadata.name,
      description: cdcMetadata.description,
      website: cdcMetadata.website,
      logo: cdcMetadata.logo,
      templates: {
        pandemic_kit: cdcPandemicKit,
        medication_kit: cdcMedicationKit,
      },
    },
    wahle_tec: {
      name: wahleTecMetadata.name,
      description: wahleTecMetadata.description,
      website: wahleTecMetadata.website,
      logo: wahleTecMetadata.logo,
      templates: {
        ifak: wahleTecIfak,
      },
    },
  };
}
